import {
    ALERTAS_ERROR,
    ALERTAS_LOADING,
    ALERTAS_SUCCESS,
    ALERTAS_RESET,
    RESET_PORTAL_CONTEXT,
  } from "../ActionTypes";
import alertasInitialState from "../initialStates/alertasInitialState";
  
  const alertas = (state, { payload, type }) => {
    switch (type) {
      case ALERTAS_LOADING:
        return {
          ...state,
          alertas: {
            ...state.alertas,
            error: false,
            loading: true,
          },
        };
      case ALERTAS_SUCCESS:
        return {
          ...state,
          alertas: {
            ...state.alertas,
            loading: false,
            error: false,
            data: payload,
          },
        };
      case ALERTAS_ERROR:
        return {
          ...state,
          alertas: {
            ...state.alertas,
            error: payload,
            loading: false,
          },
        };
  
      case ALERTAS_RESET:
        return alertasInitialState;
        
      case RESET_PORTAL_CONTEXT:
        return alertasInitialState;
  
      default:
        return state;
    }
  };
  
  export default alertas;